const Search2Icon = ({ width, height, color }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.84 12.68C10.9608 12.68 12.68 10.9608 12.68 8.84C12.68 6.71923 10.9608 5 8.84 5C6.71923 5 5 6.71923 5 8.84C5 10.9608 6.71923 12.68 8.84 12.68Z"
        stroke={color}
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M11.5349 11.7749L14.72 14.9599"
        stroke={color}
        strokeMiterlimit="10"
      />
      <path
        d="M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM1.09641 10C1.09641 14.9173 5.08269 18.9036 10 18.9036C14.9173 18.9036 18.9036 14.9173 18.9036 10C18.9036 5.08269 14.9173 1.09641 10 1.09641C5.08269 1.09641 1.09641 5.08269 1.09641 10Z"
        fill={color}
      />
    </svg>
  );
};

export default Search2Icon;
